import $ from "jquery";
import moment from "moment";
import { Row, Col } from "reactstrap";
import useModal from "../../../../core/hooks/use-modal";
import React, { useState, useEffect } from "react";
import { toast } from "../../../../core/helpers/message-helper";
import { getDayOfTheWeek } from "../../../../core/helpers/date-helper";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import DateRangePicker from "../../../../core/ui/components/DateRangePicker";
import FormExportarRecargosHorasExtras from "../components/form-exportar-recargos-horas-extras";
import { obtenerInformeEmpleados } from "../../services/informes-service";

const thStyles = { minWidth: "100px" };
const thStickyCells = { position: "sticky", left: 0 };

const Informes = () => {
    const [tHeadDates, setTHeadDates] = useState([]);
    const [dateRange, setDateRange] = useState({
        startDate: moment().subtract(10, "days"),
        endDate: moment(),
    });

    const modalExportarInformeRecargos = useModal({
        show: false,
        title: "Exportar informe de recargos - horas extras",
    });

    function getDaysColumns(dateRange) {
        const daysDifference = getDiffInDaysBetweenDates(
            dateRange.startDate,
            dateRange.endDate
        );

        return new Array(Math.ceil(daysDifference)).fill(0);
    }

    const getReport = async () => {
        $("#informeEmpleados").DataTable().clear().destroy();

        const response = await obtenerInformeEmpleados(
            dateRange.startDate.format("YYYY-MM-DD"),
            dateRange.endDate.format("YYYY-MM-DD")
        );

        const daysColumns = getDaysColumns(dateRange);
        setTHeadDates(getTHeadDates(daysColumns));
        const tableBody = response.data.map((value) =>
            mapDateToTr(value, daysColumns)
        );

        buildDatatable(tableBody);
    };

    const options = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "informeEmpleados",
        select: {
            style: "single",
        },
        destroy: true,
        columnDefs: [
            {
                className: "sticky-cells-table cells-default-background",
                targets: [0],
            },
            {
                className:
                    "sticky-cells-table-column-2 cells-default-background",
                targets: [1],
            },
        ],
        buttons: [
            {
                titleAttr: "Exportar a Excel",
                text: '<i class="fas fa-file-excel"></i>',
                extend: "excelHtml5",
                className: "btn btn-sm btn-success",
                exportOptions: {
                    modifier: {
                        order: "current",
                        page: "all",
                    },
                },
                filename: "informe-empleados",
            },
            {
                titleAttr: "Imprimir",
                text: '<i class="fa fa-lg fa-print"></i>',
                extend: "print",
                className: "btn btn-sm btn-warning",
            },
            {
                titleAttr: "Exportar informe de recargos",
                text: "Exportar informe de recargos",
                action: function () {
                    modalExportarInformeRecargos.set({
                        show: true,
                        title: "Exportar informe de recargos - horas extras",
                    });
                },
                className: "btn btn-sm btn-secondary",
            },
        ],
    };

    const buildDatatable = (rows) => {
        const table = $("#informeEmpleados").DataTable(options);
        rows.forEach((row) => table.row.add(row));
        table.draw();
    };

    const onChangeRange = function (start, end) {
        const days = getDiffInDaysBetweenDates(start, end);

        if (days <= 40) {
            setDateRange({ startDate: start, endDate: end });
        } else {
            toast.error("El rango de fecha no puede ser mayor a 40 días");
        }
    };

    function getTHeadDates(daysColumns) {
        return daysColumns.map((v, i) => {
            const startDate = dateRange.startDate.format("YYYY-MM-DD");
            const endDate = dateRange.endDate.format("YYYY-MM-DD");
            const date = moment(startDate).add(i, "days");
            const currentDate = date.format("ll");
            const dayOfTheWeek = getDayOfTheWeek(date.format("YYYY-MM-DD"));
            const tdLabel = `${dayOfTheWeek}-${currentDate}`;
            return (
                <th
                    style={thStyles}
                    className="text-center text-white"
                    key={`${startDate}-${endDate}-${tdLabel}`}
                >
                    {tdLabel}
                </th>
            );
        });
    }

    function getDiffInDaysBetweenDates(startDate, endDate) {
        const duration = moment.duration(endDate.diff(startDate));
        return duration.asDays();
    }

    useEffect(() => getReport(), [dateRange]);

    const mapDateToTr = (value, daysColumns) => {
        const dateColumns = daysColumns.map((v, i) => {
            const date = moment(dateRange.startDate.format("YYYY-MM-DD"))
                .add(i, "days")
                .format("YYYY-MM-DD");

            const fechaData = value.horas_diarias[date] ?? {
                horas_extras: {
                    diurnas: 0,
                    nocturnas: 0,
                    diurna_festiva: 0,
                    nocturna_festiva: 0,
                },
            };

            return `
                <label title="Horas Laborales">
                    HT: <strong>${fechaData?.horas ?? "0"}</strong>
                </label> <br />
                <label title="Horas Extras Diurnas">
                    HED: <strong>${fechaData.horas_extras.diurnas}</strong>
                </label> <br />
                <label title="Horas Extras Nocturnas">
                    HEN: <strong> ${fechaData.horas_extras.nocturnas}</strong>
                </label> <br />
                <label title="Horas Extras Diurnas Festivas">
                    HEDF: <strong>${fechaData.horas_extras.diurna_festiva}</strong>
                </label> <br />
                <label title="Horas Extras Nocturnas Festivas">
                    HENF: <strong> ${fechaData.horas_extras.nocturna_festiva}</strong>
                </label> <br />
                ${
                    fechaData.horas_extras.observacion != null
                        ? `<label>Observacion: <strong> ${fechaData.horas_extras.observacion}</strong> </label>`
                        : ""
                }
            `;
        });

        const alertas = value.alertas != null && value.alertas.length > 0 ? value.alertas : [];
        let alertasMensajes = '';

        alertas.forEach(alerta => {
            alertasMensajes += `- Fecha: ${alerta.fecha}, Descripcion: ${alerta.descripcion} \n`;
        });

        return [
            `<span
                title="${alertasMensajes}"
                style="color: ${alertasMensajes ? 'red': ''}"
            >
                ${value.nombres}
            </span>`,
            value.documento,
            ...dateColumns,
            value.total_horas,
            value.total_horas_extras_diurnas,
            value.total_horas_extras_nocturnas,
            value.total_horas_extras_diurnas_festivas,
            value.total_horas_extras_nocturnas_festivas,
        ];
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    NÓMINA /  Informes De Recargos y Horas Extras
                </div>
            </div>

            <Row className="justify-content-center">
                <Col lg={4} className="mt-4 mb-4">
                    <DateRangePicker
                        id="informeFecha"
                        endDate={dateRange.endDate}
                        onChangeRange={onChangeRange}
                        startDate={dateRange.startDate}
                    />
                </Col>
            </Row>

            <table
                id="informeEmpleados"
                className="w-100 table table-hover table-responsive"
            >
                <thead className="bg-dark">
                    <tr>
                        <th
                            style={{ ...thStyles, ...thStickyCells }}
                            className="bg-dark text-white text-center sticky-cells-table cells-default-background"
                        >
                            Empleado
                        </th>
                        <th
                            style={{
                                ...thStyles,
                                ...thStickyCells,
                                left: "120px",
                            }}
                            className="bg-dark text-white text-center sticky-cells-table-column-2 cells-default-background"
                        >
                            CC
                        </th>
                        {tHeadDates}
                        <th style={thStyles} className="text-center text-white">
                            Total Horas de los Turnos
                        </th>
                        <th style={thStyles} className="text-center text-white">
                            Total Horas Extras Díurnas
                        </th>
                        <th style={thStyles} className="text-center text-white">
                            Total Horas Extras Nocturnas
                        </th>
                        <th style={thStyles} className="text-center text-white">
                            Total Horas Extras Díurnas Festivas
                        </th>
                        <th style={thStyles} className="text-center text-white">
                            Total Horas Extras Nocturnas Festivas
                        </th>
                    </tr>
                </thead>
                <tbody className="text-center"></tbody>
                <FormExportarRecargosHorasExtras
                    modalState={modalExportarInformeRecargos}
                />
            </table>
        </ContentWrapper>
    );
};

export default Informes;
